import { IAstNode, IComposeFunc } from '../../typings/ast-node';
import { IToken } from '../../typings/token';
import { getCloseBracketTokenPosition } from '../../utils';
import { TokenComposeError } from '../../errors';


export function composeParenthesis(astNodes: IAstNode[], compose: IComposeFunc) {
    const start = astNodes.findIndex(({ type, token }) => {
        return type === 'Temporary' && !!token && token.type === 'OpenParenthesis';
    });
    if (start === -1) { return; }

    const tokens = astNodes.map(node => node.token) as IToken[];
    const end = getCloseBracketTokenPosition(start, tokens, 'OpenParenthesis', 'CloseParenthesis');
    if (end === -1) {
        throw new TokenComposeError('parenthesis-not-closed', '表达式缺少结束括号', tokens[start].position);
    }
    const eatNodes = astNodes.slice(start, end + 1);
    if (eatNodes.length <= 2) {
        throw new TokenComposeError('brackets-content-empty', '括号内内容不能为空', tokens[start].position);
    }
    const composedEatenNode = compose(eatNodes.slice(1, eatNodes.length - 1));
    astNodes.splice(start, eatNodes.length, composedEatenNode);
    composeParenthesis(astNodes, compose);
}
